<template>
  <path pid="0" d="M19 10a4 4 0 10-4-4 3.93 3.93 0 00.15 1.09l-5.31 3.09a4 4 0 100 5.64l5.31 3.09A3.93 3.93 0 0015 20a4 4 0 101.16-2.82l-5.31-3.09a4 4 0 000-2.18l5.31-3.09A4 4 0 0019 10zm0-6a2 2 0 11-1.72 3A2 2 0 0119 4zM8.75 14a2 2 0 110-2A2 2 0 019 13a2 2 0 01-.25 1zm8.44 5.19v-.07l.06-.1v-.1A2 2 0 1117 20a2 2 0 01.19-.84z"/>
</template>
